export default {
  escapeHTML: function escapeHTML(html) {
    var element = document.createElement('div');
    element.textContent = html;
    return element.innerHTML;
  }
};